/**
 * @file agreementApi.js
 * @description 协议详情（购卷 VOL_PAY / 橘子币 GOLD_RECHARGE）
 * @module features/comic/api/agreementApi
 */

import axios from '@/shared/utils/axios'
import API from '@/config/api'

/**
 * @typedef {Object} AgreementDetailVo
 * @property {string} code
 * @property {string} title
 * @property {string} version
 * @property {string} content HTML
 */

/**
 * 查询协议详情
 * @param {{ code: 'VOL_PAY' | 'GOLD_RECHARGE' }} payload
 * @returns {Promise<AgreementDetailVo>}
 */
export async function fetchAgreementDetailApi(payload) {
  const { data } = await axios.post(API.AGREEMENT.DETAIL, { code: payload.code })
  if (data.code !== 200 && data.code !== 0) {
    throw Object.assign(new Error(data.msg ?? data.errmsg ?? '协议暂不可用'), {
      code: data.code,
    })
  }
  return data.data
}
